<template>
  <main class="app-container">
    <div :style="`height: ${height}px;`">
      <md-scroll-view
              ref="scrollView"
              :scrolling-x="false"
              @end-reached="onReachBottom"
      >
        <div class="ch-header-paper" id="ch-header-paper">
          <div class="top">
            <h3>Leaders</h3>
            <div class="activities-search form-tg">
              <div class="activities-search-input activities-search-input--keyword">
                <input type="text" v-model="filter.name" name="name" id="activity_keyword" class="form-control" placeholder="Leader姓名">
              </div>
              <div class="activities-search-input activities-search-input--submit">
                <input type="button" name="commit" value="搜索" @click="search" class="btn-tg btn-tg-orange btn-tg-full">
              </div>
            </div>
          </div>
          <div class="bottom"></div>
        </div>

        <list-loading v-show="listData.loading && listData.query.page == 1" />
        <div class="no-result" v-show="!listData.loading && listData.data.length < 1">暂无数据</div>

        <div class="leaders">
          <div class="leader-item"
               v-for="item in listData.data"
               :key="item.id"
          >
            <router-link :to="{name:'leaders-show', params:{id:item.id}}">
            <img :src="item.avatar" alt="">
            </router-link>
            <h3>{{item.name}}</h3>
            <p>带领课程 {{item.courses_count}} 次</p>
          </div>
          <div class="clearfix"></div>
        </div>


        <md-scroll-view-more
                slot="more"
                finished-text=""
                :is-finished="listData.hasNextPage == false"
        >
        </md-scroll-view-more>
      </md-scroll-view>
    </div>




  </main>
</template>

<script>
import ListLoading from "../components/ListLoading.vue";
import listDataMixin from "../mixins/list-data";
import {ScrollView, ScrollViewMore} from 'mand-mobile'

export default {
    components: {
        ListLoading,
        [ScrollView.name]: ScrollView,
        [ScrollViewMore.name]: ScrollViewMore,
    },
    mixins: [listDataMixin],
    methods: {
        search() {
            const {filter} = this;
            this.initListData();
            const {query} = this.listData;
            this.listData.query = {...query, ...filter};
            console.log(this.listData.query);
            this.loadListData();
        },

    },
    data() {
        return {
            filter:{name:''},
            height: window.screen.height,
            apiEndpoint: 'leaders',
        }
    },
    created() {
        this.loadListData();
    },
};
</script>


<style lang="scss" scoped>
.top {
  h3 {
    margin-bottom: 40px;
  }
}

  .leaders {
    /*padding: 0 40px;*/

    .leader-item {
      width: 50%;
      text-align: center;
      float: left;
      margin-bottom: 40px;
      padding: 0 40px;
      box-sizing: border-box;

      img {
        width: 200px;
        height: 200px;
        border-radius: 50%;
      }

      h3 {
        color: #f26522;
        font-size:32px;
        margin: 10px 0;
      }
      p {
        font-size: 24px;
        color: #8f908f;
      }
    }
  }

</style>
